  /* eslint-disable */
import React from 'react'
import { Link } from 'react-router-dom';
import Svg from "_assets/svg";

function BreadCrumb(props) {
  const {dataBreadCrumb, className} = props;
  return (
    <div className={`${className} d-flex align-items-center`}>
      {
        dataBreadCrumb.map((item, index)=>{
         return <div key={index} className={`d-flex align-items-center ${item.link ? '' : ''}`}>
          {item.link ? 
            <Link to={item.link} className="fsize-14 fweight-500 cl-grey-deep text-decoration-none">
              {item.name} 
              <img src={Svg.chevron.default} className="mx-1"></img>
            </Link> :
            <span className="fsize-14 fweight-500 cl-neutral400">
              {item.name} 
            </span>
          }
          </div>
        })
      }
    </div>
  )
}

export default BreadCrumb